// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.api-key-table[data-v-26bf4be1] .v-data-table__wrapper {\n  overflow-x: auto;\n}\n", ""]);
// Exports
module.exports = exports;
